// extracted by mini-css-extract-plugin
export default {"area":"components--area--qg0U6"};